import React from "react";
import { FaGift, FaWallet } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const GiftSuccessModal = ({ isOpen, onClose, isCoupon = false, isTransfer = false, onRepay = null }) => {
    const navigate = useNavigate();
    if (!isOpen) return null;
    const confettiPieces = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        color: [
            "#FF6B35",
            "#1E3A8A",
            "#E55A2B",
            "#1E40AF",
            "#F97316",
            "#3B82F6",
        ][Math.floor(Math.random() * 6)],
        size: Math.random() * 6 + 4,
        delay: Math.random() * 1.5,
        duration: 2.5 + Math.random() * 1.5,
        left: Math.random() * 100,
        rotation: Math.random() * 360
    }));

    return (
        <div className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="relative w-full max-w-md overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-xl">
                <div className="absolute inset-0 pointer-events-none opacity-40 overflow-hidden">
                    {confettiPieces.map((piece) => (
                        <div
                            key={piece.id}
                            className="absolute rounded-full"
                            style={{
                                left: `${piece.left}%`,
                                top: "0",
                                width: `${piece.size}px`,
                                height: `${piece.size}px`,
                                background: piece.color,
                                animation: `confettiFall ${piece.duration}s ${piece.delay}s infinite linear`,
                            }}
                        />
                    ))}
                </div>

                <div className="relative z-10 px-6 sm:px-8 py-8 flex flex-col items-center text-center">
                    {!isCoupon && (
                        <div className="mb-4 flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#FF6B35] to-[#1E3A8A] shadow-md">
                            <FaGift className="text-xl text-white" />
                        </div>
                    )}

                    {isCoupon ? (
                        <div className="space-y-3">
                            <h2 className="text-lg font-bold text-[#1E3A8A]">
                                Repay now and unlock rewards
                            </h2>
                            <p className="text-sm text-gray-600 leading-relaxed max-w-[280px]">
                                Clear your current dues to receive exclusive Snap Paisa coupons for your next journey.
                            </p>
                            <button
                                onClick={() => {
                                    onClose();
                                    navigate("/dashboard");
                                }}
                                className="mt-2 inline-flex min-w-[180px] items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#FF6B35] to-[#1E3A8A] px-6 py-3 font-semibold text-white shadow-md transition hover:shadow-lg hover:opacity-95"
                            >
                                <FaWallet className="h-4 w-4" />
                                Repay with Snap Paisa
                            </button>
                        </div>
                    ) : isTransfer ? (
                        <div className="space-y-3">
                            <h2 className="text-lg font-bold text-[#1E3A8A]">
                                Thanks for your support
                            </h2>
                            <p className="text-sm text-gray-600 leading-relaxed max-w-[300px]">
                                Your loan disbursal has been successfully initiated and the amount will be credited to your bank account shortly.
                            </p>
                            <button
                                onClick={onClose}
                                className="mt-2 rounded-xl bg-gradient-to-r from-[#FF6B35] to-[#1E3A8A] px-8 py-3 font-semibold text-white shadow-md transition hover:shadow-lg hover:opacity-95"
                            >
                                Got it!
                            </button>
                        </div>
                    ) : (
                        <div className="space-y-3">
                            <h2 className="text-lg font-bold text-[#1E3A8A]">
                                Surprise unlocked!
                            </h2>
                            <p className="text-sm text-gray-600 leading-relaxed max-w-[280px]">
                                Your Snap Paisa gift is on its way. Keep an eye on your doorstep for a bright delivery.
                            </p>
                            <button
                                onClick={onClose}
                                className="mt-2 rounded-xl bg-gradient-to-r from-[#FF6B35] to-[#1E3A8A] px-8 py-3 font-semibold text-white shadow-md transition hover:shadow-lg hover:opacity-95"
                            >
                                Got it!
                            </button>
                        </div>
                    )}
                </div>

                <style jsx>{`
          @keyframes confettiFall {
            0% {
              transform: translateY(0) rotateZ(0deg);
              opacity: 1;
            }
            100% {
              transform: translateY(420px) rotateZ(360deg);
              opacity: 0;
            }
          }
        `}</style>
            </div>
        </div>
    );
};

export default GiftSuccessModal;
